import { render, staticRenderFns } from "./contact-people-table.vue?vue&type=template&id=782eb16e&"
import script from "./contact-people-table.vue?vue&type=script&lang=js&"
export * from "./contact-people-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports